import { render, staticRenderFns } from "./roleChoice.vue?vue&type=template&id=2fd37545&scoped=true"
import script from "./roleChoice.vue?vue&type=script&lang=js"
export * from "./roleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd37545",
  null
  
)

export default component.exports